import { defineMessages } from 'react-intl';

export default defineMessages({

  selectYourHardship: {
    id: 'fastCover.medicalHardshipStep.selectYourHardship',
    defaultMessage: 'Select your hardship',
  },
  criticalIllness: {
    id: 'fastCover.medicalHardshipStep.criticalIllness',
    defaultMessage: 'Critical Illness',
  },
  disability: {
    id: 'fastCover.medicalHardshipStep.disability',
    defaultMessage: 'Disability',
  },
  dismemberment: {
    id: 'fastCover.medicalHardshipStep.dismemberment',
    defaultMessage: 'Dismemberment',
  },
  leaveOfAbsence: {
    id: 'fastCover.medicalHardshipStep.leaveOfAbsence',
    defaultMessage: 'Leave Of Absence',
  },
  death: {
    id: 'fastCover.medicalHardshipStep.death',
    defaultMessage: 'Death',
  },
  whatEventHappened: {
    id: 'fastCover.medicalHardshipStep.whatEventHappened',
    defaultMessage: 'What Event Happened?',
  },
  illness: {
    id: 'fastCover.medicalHardshipStep.illness',
    defaultMessage: 'Illness',
  },
  injury: {
    id: 'fastCover.medicalHardshipStep.injury',
    defaultMessage: 'Injury',
  },
  cancer: {
    id: 'fastCover.medicalHardshipStep.cancer',
    defaultMessage: 'Cancer',
  },
  coronaryHeartDisease: {
    id: 'fastCover.medicalHardshipStep.coronaryHeartDisease',
    defaultMessage: 'Coronary Heart Disease',
  },
  heartAttack: {
    id: 'fastCover.medicalHardshipStep.heartAttack',
    defaultMessage: 'Heart Attack',
  },
  stroke: {
    id: 'fastCover.medicalHardshipStep.stroke',
    defaultMessage: 'Stroke',
  },
  whatDateDidThisOccur: {
    id: 'fastCover.medicalHardshipStep.whatDateDidThisOccur',
    defaultMessage: 'What date did this occur?',
  },
  areYouInACareFacilityCurrently: {
    id: 'fastCover.medicalHardshipStep.areYouInACareFacilityCurrently',
    defaultMessage: 'Are you in a care facility currently?',
  },
  yes: {
    id: 'fastCover.medicalHardshipStep.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'fastCover.medicalHardshipStep.no',
    defaultMessage: 'No',
  },
  typeOfCareFacility: {
    id: 'fastCover.medicalHardshipStep.typeOfCareFacility',
    defaultMessage: 'Type of care facility',
  },
  didYouGoToAHospitalCurrently: {
    id: 'fastCover.medicalHardshipStep.didYouGoToAHospitalCurrently',
    defaultMessage: 'Did you go to a hospital currently?',
  },
  didYourEmployerAllowYouAnApprovedLeaveOfAbsence: {
    id: 'fastCover.medicalHardshipStep.didYourEmployerAllowYouAnApprovedLeaveOfAbsence',
    defaultMessage: 'Did your employer allow you an approved leave of absence?',
  },
  onWhatDateDidYourLeaveStart: {
    id: 'fastCover.medicalHardshipStep.onWhatDateDidYourLeaveStart',
    defaultMessage: 'On what date did your leave start?',
  },
  employerName: {
    id: 'fastCover.medicalHardshipStep.employerName',
    defaultMessage: 'Employer Name',
  },
  employerEmail: {
    id: 'fastCover.medicalHardshipStep.employerEmail',
    defaultMessage: 'Employer Email',
  },
  benefitDoesNotExtendToSelfEmployed: {
    id: 'fastCover.medicalHardshipStep.benefitDoesNotExtendToSelfEmployed',
    defaultMessage: '1) Benefit does not extend to self-employed, retired, or employed by a member of your Household.',
  },
  attachACopyOfYourApprovedLeaveNotice: {
    id: 'fastCover.medicalHardshipStep.attachACopyOfYourApprovedLeaveNotice',
    defaultMessage: '2) Attach a copy of your approved leave notice, that shows your employer’s name, address, and contact information for the approving person.',
  },
  dateSicknessOrInjuryBegan: {
    id: 'fastCover.medicalHardshipStep.dateSicknessOrInjuryBegan',
    defaultMessage: 'Date Sickness or Injury began',
  },
  // Old
  areYouClaimingForAccidentalDeathAndDismemberment: {
    id: 'fastCover.medicalHardshipStep.areYouClaimingForAccidentalDeathAndDismemberment',
    defaultMessage: 'Are you claiming for Accidental Death & Dismemberment?',
  },
  areYouClaimingForCommonCarrierAccidentalDeathAndDismemberment: {
    id: 'fastCover.medicalHardshipStep.areYouClaimingForCommonCarrierAccidentalDeathAndDismemberment',
    defaultMessage: 'Are you claiming for Common Carrier Accidental Death & Dismemberment??',
  },
  groupName: {
    id: 'fastCover.medicalHardshipStep.groupName',
    defaultMessage: 'Groups Name',
  },
  claimantSection: {
    id: 'fastCover.medicalHardshipStep.claimantSection',
    defaultMessage: 'Claimant Section',
  },
  relationshipToInsured: {
    id: 'fastCover.medicalHardshipStep.relationshipToInsured',
    defaultMessage: 'Relationship To Insured',
  },
  self: {
    id: 'fastCover.medicalHardshipStep.self',
    defaultMessage: 'Self',
  },
  spouse: {
    id: 'fastCover.medicalHardshipStep.spouse',
    defaultMessage: 'Spouse',
  },
  child: {
    id: 'fastCover.medicalHardshipStep.child',
    defaultMessage: 'Child',
  },
  other: {
    id: 'fastCover.medicalHardshipStep.other',
    defaultMessage: 'Other',
  },
  placeWhereAccidentHappened: {
    id: 'fastCover.medicalHardshipStep.placeWhereAccidentHappened',
    defaultMessage: 'Place where accident happened',
  },
  cityOrTown: {
    id: 'fastCover.medicalHardshipStep.cityOrTown',
    defaultMessage: 'City or Town',
  },
  country: {
    id: 'fastCover.medicalHardshipStep.country',
    defaultMessage: 'Country',
  },
  state: {
    id: 'fastCover.medicalHardshipStep.state',
    defaultMessage: 'State',
  },
  postalCode: {
    id: 'fastCover.medicalHardshipStep.postalCode',
    defaultMessage: 'Postal Code',
  },
  dateOfAccident: {
    id: 'fastCover.medicalHardshipStep.dateOfAccident',
    defaultMessage: 'Date Of Accident',
  },
  describeHowTheAccidentOccurred: {
    id: 'fastCover.medicalHardshipStep.describeHowTheAccidentOccurred',
    defaultMessage: 'Describe how the Accident occurred',
  },
  dateOfDismembermentOrLossOfUse: {
    id: 'fastCover.medicalHardshipStep.dateOfDismembermentOrLossOfUse',
    defaultMessage: 'Date of Dismemberment/Loss of Use',
  },
  dateOfDeath: {
    id: 'fastCover.medicalHardshipStep.dateOfDeath',
    defaultMessage: 'Date of Death',
  },
  hospitalConfined: {
    id: 'fastCover.medicalHardshipStep.hospitalConfined',
    defaultMessage: 'Hospital Confined',
  },
  dates: {
    id: 'fastCover.medicalHardshipStep.dates',
    defaultMessage: 'Dates',
  },
  hospital: {
    id: 'fastCover.medicalHardshipStep.hospital',
    defaultMessage: 'Hospital',
  },

  isRequired: {
    id: 'fastCover.medicalHardshipStep.isRequired',
    defaultMessage: "'{defaultMessage}' is required",
  },

  address: {
    id: 'fastCover.medicalHardshipStep.address',
    defaultMessage: 'Address',
  },

  bothHandsOrBothFeet: {
    id: 'fastCover.medicalHardshipStep.bothHandsOrBothFeet',
    defaultMessage: 'Both hands or both feet',
  },

  sightOfBothEyes: {
    id: 'fastCover.medicalHardshipStep.sightOfBothEyes',
    defaultMessage: 'Sight of both eyes',
  },

  oneHandAndOneFoot: {
    id: 'fastCover.medicalHardshipStep.oneHandAndOneFoot',
    defaultMessage: 'One hand and one foot',
  },

  oneArmFromTheShoulderDownToTheHand: {
    id: 'fastCover.medicalHardshipStep.oneArmFromTheShoulderDownToTheHand',
    defaultMessage: 'One arm from the shoulder down to the hand',
  },

  oneLegFromTheHipDownToTheFoot: {
    id: 'fastCover.medicalHardshipStep.oneLegFromTheHipDownToTheFoot',
    defaultMessage: 'One leg from the hip down to the foot',
  },

  whatDateThisOccur: {
    id: 'fastCover.medicalHardshipStep.whatDateThisOccur',
    defaultMessage: 'What date this this occur?',
  },

  natureOfDismemberment: {
    id: 'fastCover.medicalHardshipStep.natureOfDismemberment',
    defaultMessage: 'Nature of Dismemberment',
  },

  areYouRetired: {
    id: 'fastCover.medicalHardshipStep.areYouRetired',
    defaultMessage: 'Are you retired, self-employed or are employed by a member of Your Household?',
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.DuesProtect.MedicalHardshipStep/messages.js